import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from '@purespectrum1/ui/tabs';
import { ModalModule } from '@purespectrum1/ui/modal';
import { SliderModule } from '@purespectrum1/ui/slider';
import { ButtonModule } from '@purespectrum1/ui/button';
import { SelectDropdownModule } from '@purespectrum1/ui/select-dropdown';
import { DropdownModule } from '@purespectrum1/ui/dropdown';
import { GoogleTagManagerModule } from '@purespectrum1/ui/tracking';
import { Daterangepicker } from 'ng2-daterangepicker';
import { ConfigEnabledModule } from '../create-surveys/shared/ui/config-enabled/config-enabled.module';
import { MultiCountryModule } from '../create-surveys/shared/ui/multicountry/multi-country.module';
import {
  HeaderComponent,
  LayoutModule,
} from '../create-surveys/layout/layout.module';
import { CreateSurveyModule } from '../create-surveys/create-surveys.module';
import { ManageSurveyTabsModule } from '../manage-survey-tabs/manage-survey-tabs.module';
import { EnvironmentConfig } from '../shared/interfaces/environment.interface';
import { HasRoleModule } from '../shared/ui/has-role/has-role.module';
import { SortTableModule } from '../shared/ui/sort-table/sort-table.module';
import { BuyerEntryLinkViewModalComponent } from './buyer-entry-link-view-modal/buyer-entry-link-view-modal.component';
import { BuyerRedirectGuideComponent } from './buyer-redirect-guide/buyer-redirect-guide.component';
import { ClearOrViewPsidModalComponent } from './clear-or-view-psid-modal/clear-or-view-psid-modal.component';
import { LaunchModalComponent } from './launch-modal/launch-modal.component';
import { MissingLiveUrlModalComponent } from './missing-live-url-modal/missing-live-url-modal.component';
import { NightcrawlerComponent } from './nightcrawler/nightcrawler.component';
import { QuotaLevelTrackingModalComponent } from './quota-mapper/quota-level-tracking-modal/quota-level-tracking-modal.component';
import { QuotaMapperComponent } from './quota-mapper/quota-mapper.component';
import { SurveyLaunchComponent } from './survey-launch.component';
import { AccordionModule } from '@purespectrum1/ui/accordion';
import { InputRestrictionModule } from '../create-surveys/shared/ui/input-restriction/input-restriction.module';
import { IncludeListComponent } from './include-list/include-list.component';
import { DisableControlModule } from '../shared/ui/disable-control/disable-control.module';
import { BillingNumberTooltipModule } from '../shared/ui/billing-number-tooltip/billing-number-tooltip.module';
import { MissingMarkersModalModule } from '../shared/ui/missing-markers-modal/missing-markers-modal.module';

@NgModule({
  declarations: [
    SurveyLaunchComponent,
    BuyerEntryLinkViewModalComponent,
    BuyerRedirectGuideComponent,
    QuotaMapperComponent,
    LaunchModalComponent,
    MissingLiveUrlModalComponent,
    QuotaLevelTrackingModalComponent,
    ClearOrViewPsidModalComponent,
    NightcrawlerComponent,
    IncludeListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputRestrictionModule,
    SliderModule,
    TabsModule,
    AccordionModule,
    ButtonModule,
    ModalModule,
    Daterangepicker,
    SortTableModule,
    SelectDropdownModule,
    ConfigEnabledModule,
    LayoutModule,
    HasRoleModule,
    MultiCountryModule,
    DropdownModule,
    CreateSurveyModule,
    ManageSurveyTabsModule,
    GoogleTagManagerModule,
    DisableControlModule,
    BillingNumberTooltipModule,
    MissingMarkersModalModule,
  ],
  exports: [
    SurveyLaunchComponent,
    QuotaMapperComponent,
    BuyerRedirectGuideComponent,
    LaunchModalComponent,
    MissingLiveUrlModalComponent,
    QuotaLevelTrackingModalComponent,
    ClearOrViewPsidModalComponent,
    HeaderComponent,
  ],
})
export class SurveyLaunchModule {
  static forRoot(
    config: EnvironmentConfig
  ): ModuleWithProviders<SurveyLaunchModule> {
    return getModuleSettings(config);
  }
  static forChild(
    config: EnvironmentConfig
  ): ModuleWithProviders<SurveyLaunchModule> {
    return getModuleSettings(config);
  }
}

const getModuleSettings = (config: EnvironmentConfig) => {
  return {
    ngModule: SurveyLaunchModule,
    providers: [
      {
        provide: 'ENV',
        useValue: config || {},
      },
    ],
  };
};
